export const artists = [
  {
    id: 1,
    name: "Neon Nights",
    followers: "125K",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=150&h=150&fit=crop",
    genre: "Synthwave",
    bio: "Pioneer of modern synthwave music"
  },
  {
    id: 2,
    name: "Retro Wave",
    followers: "89K",
    image: "https://images.unsplash.com/photo-1571330735066-03aaa9429d89?w=150&h=150&fit=crop",
    genre: "Electronic",
    bio: "Creating nostalgic electronic soundscapes"
  },
  {
    id: 3,
    name: "Vintage Vibes",
    followers: "203K",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=150&h=150&fit=crop",
    genre: "Chillwave",
    bio: "Atmospheric and dreamy electronic music"
  }
];
